(function(angular){
	'use strict';
	
	angular.module('revealModule', ['BaseConfig']);

})(window.angular);